export const DEFAULT_THEME = "default";
export const COLOR_MODES = {
  LIGHT: "light",
  DARK: "dark",
};
export const DEFAULT_COLOR_MODE = COLOR_MODES.DARK;

export const isColorMode = (colorMode) => {
  return Object.values(COLOR_MODES).includes(colorMode);
};

export const availableThemes = [
  {
    name: DEFAULT_THEME,
    appClassName: "",
    bodyClassName: "",
    themeColor: "#000000",
    themeColors: {
      [COLOR_MODES.LIGHT]: "#f6f0de",
      [COLOR_MODES.DARK]: "#000000",
    },
  },
  {
    name: "enclave",
    appClassName: "theme-enclave",
    bodyClassName: "theme-enclave-body",
    themeColor: "#0b1517",
    themeColors: {
      [COLOR_MODES.LIGHT]: "#f6f0de",
      [COLOR_MODES.DARK]: "#0b1517",
    },
  },
];

export const getThemeByName = (themeName) => {
  const normalizedThemeName = themeName || DEFAULT_THEME;

  return (
    availableThemes.find((theme) => theme.name === normalizedThemeName) ||
    availableThemes.find((theme) => theme.name === DEFAULT_THEME)
  );
};
